import { Component, OnInit, Type } from '@angular/core';
import {
  FieldArrayType,
  FieldArrayTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';

export interface RepeatFixProps extends FormlyFieldProps {
  count: number;
}

export interface FormlyRepeatFixFieldConfig extends FormlyFieldConfig<RepeatFixProps> {
  type: 'repeat-fix' | Type<RepeatFixComponent>;
}

@Component({
  selector: 'vectronic-formly-repeat-fix',
  imports: [FormlyModule],
  templateUrl: './repeat-fix.component.html',
  styleUrls: ['./repeat-fix.component.scss'],
})
export class RepeatFixComponent
  extends FieldArrayType<FieldArrayTypeConfig<RepeatFixProps>>
  implements OnInit
{
  ngOnInit() {
    for (let i = 0; i < this.props.count; i++) {
      this.add();
    }
  }
}
